"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.readSubId = void 0;
const decodeBase64 = (base64) => (typeof atob === 'undefined' ? Buffer.from(base64, 'base64').toString('utf8') : atob(base64));
const parseJwt = (token) => {
    let base64Uri = token.split('.')[1];
    base64Uri = base64Uri.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(decodeBase64(base64Uri) // Ensure node.js v16
        .split('')
        // eslint-disable-next-line prefer-template
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join(''));
    return JSON.parse(jsonPayload);
};
const getCookieValue = (name) => { var _a, _b; return (_b = (_a = new RegExp(`(^|;)\\s*'${name}'\\s*=\\s*([^;]+)`).exec(document.cookie)) === null || _a === void 0 ? void 0 : _a.pop()) !== null && _b !== void 0 ? _b : null; };
// eslint-disable-next-line import/prefer-default-export
const readSubId = (identityTokenKey) => {
    let subId = null;
    try {
        if ((document === null || document === void 0 ? void 0 : document.cookie) != null && identityTokenKey) {
            const cookie = getCookieValue(identityTokenKey);
            if (cookie != null) {
                const escapedCookieData = decodeURIComponent(cookie);
                const parsedJson = JSON.parse(escapedCookieData);
                const accessTokenData = parsedJson.access_token;
                const parsedJwt = parseJwt(accessTokenData);
                subId = parsedJwt.sub;
            }
        }
    }
    catch (_a) {
        subId = null;
    }
    return subId;
};
exports.readSubId = readSubId;
